export default {
    SET_HK_TOKEN: 'SET_HK_TOKEN',
    SET_HK_INFO: 'SET_HK_INFO',
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SET_USERS: 'SET_USERS',
    SET_USER_EMAIL: 'SET_USER_EMAIL',
    SET_TAXI_TYPES: 'SET_TAXI_TYPES',
    SET_BUSES: 'SET_BUSES',
    SET_TRAVEL_OFFERS: 'SET_TRAVEL_OFFERS',
    SET_TAXI_REQUESTS: 'SET_TAXI_REQUESTS',
    SET_FEEDBACK: 'SET_FEEDBACK'
}
